var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"stars"},[(_vm.fullStars)?_c('span',{staticClass:"star__full"},[_vm._v(_vm._s('★'.repeat(_vm.fullStars)))]):_vm._e(),(_vm.halfStar)?_c('span',{staticClass:"star__half"},[_vm._v("★")]):_vm._e(),(_vm.emptyStars)?_c('span',{staticClass:"star__empty"},[_vm._v(_vm._s('★'.repeat(_vm.emptyStars)))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }